'use client';

// framer-motion animations removed due to runtime errors
// Link import removed as using plain anchors
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { useUser } from "@/context/UserContext";

const PremiumIcon = () => (
  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M21.8382 11.1263L21.609 13.5616C21.2313 17.5742 21.0425 19.5805 19.8599 20.7902C18.6773 22 16.9048 22 13.3599 22H10.6401C7.09517 22 5.32271 22 4.14009 20.7902C2.95748 19.5805 2.76865 17.5742 2.391 13.5616L2.16181 11.1263C1.9818 9.2137 1.8918 8.25739 2.21899 7.86207C2.39598 7.64823 2.63666 7.5172 2.89399 7.4946C3.36968 7.45282 3.96708 8.1329 5.16187 9.49307C5.77977 10.1965 6.08872 10.5482 6.43337 10.6027C6.62434 10.6328 6.81892 10.6018 6.99526 10.5131C7.31351 10.3529 7.5257 9.91812 7.95007 9.04852L10.1869 4.46486C10.9888 2.82162 11.3898 2 12 2C12.6102 2 13.0112 2.82162 13.8131 4.46485L16.0499 9.04851C16.4743 9.91812 16.6865 10.3529 17.0047 10.5131C17.1811 10.6018 17.3757 10.6328 17.5666 10.6027C17.9113 10.5482 18.2202 10.1965 18.8381 9.49307C20.0329 8.1329 20.6303 7.45282 21.106 7.4946C21.3633 7.5172 21.604 7.64823 21.781 7.86207C22.1082 8.25739 22.0182 9.2137 21.8382 11.1263ZM12.9524 12.699L12.8541 12.5227C12.4741 11.841 12.2841 11.5002 12 11.5002C11.7159 11.5002 11.5259 11.841 11.1459 12.5227L11.0476 12.699C10.9397 12.8927 10.8857 12.9896 10.8015 13.0535C10.7173 13.1174 10.6125 13.1411 10.4028 13.1886L10.2119 13.2318C9.47396 13.3987 9.10501 13.4822 9.01723 13.7645C8.92945 14.0468 9.18097 14.3409 9.68403 14.9291L9.81418 15.0813C9.95713 15.2485 10.0286 15.3321 10.0608 15.4355C10.0929 15.5389 10.0821 15.6504 10.0605 15.8734L10.0408 16.0765C9.96476 16.8613 9.92674 17.2538 10.1565 17.4282C10.3864 17.6027 10.7318 17.4436 11.4227 17.1255L11.6014 17.0432C11.7978 16.9528 11.8959 16.9076 12 16.9076C12.1041 16.9076 12.2022 16.9528 12.3986 17.0432L12.5773 17.1255C13.2682 17.4436 13.6136 17.6027 13.8435 17.4282C14.0733 17.2538 14.0352 16.8613 13.9592 16.0765L13.9395 15.8734C13.9179 15.6504 13.9071 15.5389 13.9392 15.4355C13.9714 15.3321 14.0429 15.2485 14.1858 15.0813L14.316 14.9291C14.819 14.3409 15.0706 14.0468 14.9828 13.7645C14.895 13.4822 14.526 13.3987 13.7881 13.2318L13.5972 13.1886C13.3875 13.1411 13.2827 13.1174 13.1985 13.0535C13.1143 12.9896 13.0603 12.8927 12.9524 12.699Z" fill="#e5a50a"/>
  </svg>
);
import { AnimateOnView } from "@/components/ui/AnimateOnView";
// removed animation variants import

import { isPremiumPlan } from "@/constants/plans";

export default function PremiumCTA() {
  const { user } = useUser();
  const isPremium = user?.isPremium || isPremiumPlan(user?.currentPlanCode);

  // Não mostrar o CTA para usuários premium
  if (isPremium) {
    return (
      <AnimateOnView as="section" id="premium" className="relative overflow-hidden rounded-3xl border border-brand-secondary/30 bg-gradient-to-br from-brand-surface via-brand-dark to-black p-5 sm:p-8 shadow-soft">
        <div className="flex flex-col items-center justify-center gap-4 text-center lg:flex-row lg:text-left">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-brand-secondary/20 text-brand-secondary">
            <FontAwesomeIcon icon={faCheckCircle} className="h-8 w-8" />
          </div>
          <div className="space-y-1">
            <h2 className="text-xl font-semibold text-white sm:text-2xl">
              Você já é Premium! 🎉
            </h2>
            <p className="text-sm text-slate-300 sm:text-base">
              Aproveite seus downloads ilimitados e todos os recursos exclusivos.
            </p>
          </div>
          <a
            href="/conta"
            className="ml-auto inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-5 py-2.5 text-sm font-semibold text-white transition-transform hover:scale-105"
          >
            Minha Conta
          </a>
        </div>
      </AnimateOnView>
    );
  }

  return (
    <AnimateOnView as="section" id="premium" className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-brand-surface via-brand-dark to-black p-5 sm:p-8 shadow-soft">
      <div className="grid gap-6 lg:gap-10 lg:grid-cols-[1.4fr,1fr]">
        <div className="space-y-4">
          <span className="inline-flex items-center gap-2 rounded-full bg-brand-secondary/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.25em] text-brand-secondary sm:px-4 sm:text-xs border border-brand-secondary/20">
            Upgrade Premium
          </span>
          <h2 className="text-2xl leading-snug font-semibold text-white sm:text-4xl">
            Desbloqueie assets ilimitados, automações e lançamentos exclusivos primeiro.
          </h2>
          <p className="max-w-2xl text-sm text-slate-300 sm:text-base">
            Assinantes premium contam com IA de remoção de fundo em lote, integrações com Figma e edição colaborativa em tempo real.
          </p>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="/planos"
              className="inline-flex items-center gap-2 rounded-full bg-brand-secondary px-5 py-2.5 text-sm font-bold text-brand-dark shadow-[0_0_20px_rgba(34,197,94,0.4)] transform transition-transform duration-200 hover:scale-105 active:scale-95 sm:px-6 sm:py-3"
            >
              <PremiumIcon />
              Seja Premium
            </a>
            <a
              href="#entrar"
              className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-2.5 text-sm font-semibold text-white transform transition-transform duration-200 hover:bg-white/10 active:scale-95 sm:px-6 sm:py-3"
            >
              <FontAwesomeIcon icon={faUserPlus} className="h-4 w-4" />
              Saiba mais
            </a>
          </div>
        </div>
        <div id="entrar" className="rounded-2xl border border-white/10 bg-black/40 p-5 backdrop-blur-lg sm:rounded-3xl sm:p-6 shadow-lg">
          <h3 className="text-base font-semibold text-white sm:text-lg">Já tem uma conta?</h3>
          <p className="mt-2 text-xs text-slate-400 sm:text-sm">
            Faça login para sincronizar favoritos, continuar fluxos criativos e acompanhar estatísticas de engajamento.
          </p>
          <div className="mt-4 flex flex-col gap-2 sm:mt-5 sm:gap-3">
            <a
              href="/login"
              className="inline-flex items-center justify-center rounded-full bg-brand-primary px-4 py-2.5 text-sm font-semibold text-white shadow-[0_0_15px_rgba(124,58,237,0.4)] transition-transform hover:scale-[1.02] sm:px-5 sm:py-3"
            >
              Começar a usar
            </a>
            <a
              href="/cadastro"
              className="inline-flex items-center justify-center rounded-full border border-white/10 bg-white/5 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/10 sm:px-5 sm:py-3"
            >
              Criar conta gratuita
            </a>
          </div>
        </div>
      </div>
      <div className="pointer-events-none absolute -right-16 -top-16 hidden h-64 w-64 rounded-full bg-brand-primary/20 opacity-40 blur-3xl md:block" aria-hidden />
    </AnimateOnView>
  );
}
